webix.protoUI({
	name:"formlate",
	setValue:function(a){ return this.setHTML(a); },
	getValue:function(){ return ""; }
}, webix.ui.template);